"use client"

import Image from "next/image"
import { Suspense } from "react";
import { useEffect } from "react";
import { PaymentTabs } from "@/components/payment/PaymentTabs";
import { TabsContent } from "@/components/ui/tabs";
import { PaymentRecharge } from "../../payment/PricingPaymentRecharge";
import { PaymentUpgrade } from "../../payment/PricingPaymentUpgrade";
import { usePaymentParams } from "@/hooks/usePaymentParams";
import Loading from "@/components/Loading";
import { PaymentType } from "@/stores/slices/commonSlice";
import { resolvePaymentTabs } from "@/lib/payment";
import { useGlobalConfig } from "@/stores/appStore";

function PricingContent() {
  usePaymentParams();
  const { globalConfig } = useGlobalConfig();

  useEffect(() => {
    globalConfig.fetch();
  }, [globalConfig]);

  const paymentTabs = resolvePaymentTabs(globalConfig.value?.paymentTabs);

  const renderTabContent = (value: PaymentType) => {
    switch (value) {
      case 'upgrade':
        return <PaymentUpgrade membershipPlan="plus" />;
      case 'upgradePlus3x':
        return <PaymentUpgrade membershipPlan="plus3x" />;
      case 'recharge':
        return <PaymentRecharge />;
      default:
        return null;
    }
  };

  return (
    <div
      className="flex flex-1 relative flex-col"
    >
      <Image className="absolute min-w-[1440px] self-center pointer-events-none" alt="" src="https://oss.findinai.cn/images/landing-pricing-bg.png" width={2100} height={520} />
      <div className="container">
        <div className="pt-14">
          <PaymentTabs>
            {paymentTabs.map((tab) => (
              <TabsContent key={tab.value} value={tab.value} className="mt-0">
                {renderTabContent(tab.value)}
              </TabsContent>
            ))}
          </PaymentTabs>
        </div>
      </div>
    </div >
  )
}

export function Pricing() {
  return (
    <Suspense fallback={<Loading mask />}>
      <PricingContent />
    </Suspense>
  );
}

